import request from '@/utils/request'
import axios from 'axios'

const api = {
  user: '/user',
  role: '/role',
  service: '/service',
  permission: '/permission',
  permissionNoPager: '/permission/no-pager',
  orgTree: '/org/tree'
}

export default api

export function downFile (url, parameter) {
  return request({
    url: url,
    params: parameter,
    method: 'get',
    responseType: 'blob'
  })
}

export function getUserList (parameter) {
  return request({
    url: api.user,
    method: 'get',
    params: parameter
  })
}

export function searchPlace (parameter) {
  // debugger
  return axios({
    url: '/api/amap/v3/place/text?keywords=' + parameter + '&output=json&offset=20&page=1&city=%E9%83%B4%E5%B7%9E&key=bc4a4ff921bd4362e3502465513808b0&extensions=all',
    method: 'get'
  })
}

export function lonLatSearchPlace (x, y) {
  // debugger
  return axios({
    url: '/api/amap/v3/geocode/regeo?output=json&location=' + x + ',' + y + '&key=bc4a4ff921bd4362e3502465513808b0&radius=1000&extensions=all',
    method: 'get'
  })
}

export function geoserverWFS (workSpace, name, query) {
  // debugger
  return axios({
    url: '/api/geoserver/' + workSpace + '/wms?service=wfs&version=1.0.0&request=GetFeature&typeName=' + workSpace + ':' + name + '&outputFormat=application/json' + query,
    method: 'get'
  })
}

export function getRoleList (parameter) {
  return request({
    url: api.role,
    method: 'get',
    params: parameter
  })
}

// 获取管径大小 /pipe-network/pipes/pipe-diameter-size/option
export function getPipeDiameterSize () {
  return request({
    url: '/pipe-network/pipes/pipe-diameter-size/option'
  })
}

// 获取管材质 /pipe-network/pipes/pipe-line-material/option
export function getPipeLineMaterial () {
  return request({
    url: '/pipe-network/pipes/pipe-line-material/option'
  })
}

// 查询受影响用户物探点位
export function getGeophysicalPoint (parameter) {
  return request({
    url: '/pipe-network/pipe_network_brake_valve_users/geophysical-point-number?geophysicalPointNumber=' + parameter,
    method: 'get'
  })
}

// 查询数据的区域
export function getCqlExtent (parameter) {
  return request({
    url: '/pipe-network/line-layers/location/cql?cql=' + parameter,
    method: 'get'
  })
}

// 查询累计流量
export function getMeterHistory (parameter) {
  return request({
    url: '/pipe-network/meter-history/daily/flow',
    method: 'get',
    params: parameter
  })
}

/**
 * 新数据管线字段筛选统计
 * @param properties 字段
 */
export function listByGroupBatchNo (properties, stateType) {
  return request({
    url: '/pipe-network/gis/pipe-line/data-check/list-group-batch?properties=' + properties + '&stateType=' + stateType,
    method: 'get'
  })
}

/**
 * 新数据管线字段筛选统计
 * @param properties 字段
 */
export function listByGroupProperties (properties) {
  return request({
    url: '/pipe-network/gis/pipe-lines/list-group-properties?properties=' + properties
  })
}

/**
 * 新数据物探点字段筛选统计
 * @param properties 字段
 */
export function listPipeNetworkByGroupProperties (properties) {
  return request({
    url: '/pipe-network/gis/pipe-networks/list-group-properties?properties=' + properties
  })
}

// 查询新数据的区域

export function getGisCqlExtent (parameter) {
  return request({
    url: '/pipe-network/gis/pipe-lines/location/cql?cql=' + parameter,
    method: 'get'
  })
}

// 查询新数据物探点的区域

export function getGisNetWorkCqlExtent (parameter) {
  return request({
    url: '/pipe-network/gis/pipe-networks/location/cql?cql=' + parameter,
    method: 'get'
  })
}

export function getServiceList (parameter) {
  return request({
    url: api.service,
    method: 'get',
    params: parameter
  })
}
// 根据主阀门查询互通阀门
export function getMainValveIdByInterflow (proms) {
  return request({
    url: `/pipe-network/gis/pipe-networks/influence/work`,
    method: 'get',
    params: proms
  })
}
// 查询受影响的点经纬度
export function getInfluencePoint (parameter) {
  return request({
    url: `/pipe-network/gis/pipe-networks/influence/list`,
    method: 'get',
    params: parameter
  })
}

// 查询轨迹
export function getTaskTravel (parameter) {
  return request({
    url: `/pipe-network/task_travel_trajectory/page`,
    method: 'get',
    params: parameter
  })
}

export function getPermissions (parameter) {
  return request({
    url: api.permissionNoPager,
    method: 'get',
    params: parameter
  })
}

export function getOrgTree (parameter) {
  return request({
    url: api.orgTree,
    method: 'get',
    params: parameter
  })
}

// id == 0 add     post
// id != 0 update  put
export function saveService (parameter) {
  return request({
    url: api.service,
    method: parameter.id === 0 ? 'post' : 'put',
    data: parameter
  })
}

export function saveSub (sub) {
  return request({
    url: '/sub',
    method: sub.id === 0 ? 'post' : 'put',
    data: sub
  })
}

export function getLegendDetailByCode (code) {
  return request({
    url: '/manager/base-legend/detail?legendCode=' + code
  })
}

export function getLayerDetailByLayerCode (code) {
  return request({
    url: '/manager/base-layer/code?layerCode=' + code
  })
}

export function getByPipeLineLayerByZoneId (zoneId) {
  return request({
    url: '/manager/base-layer/zone_pipe_line_layer/' + zoneId
  })
}

export function listChildrenByDictCode (dictCode) {
  return request({
    url: '/manager/dicts/children?dictCode=' + dictCode
  })
}

export function getZoneMetering () {
  return request({
    url: '/zone-metering/zone-metering/user'
  })
}

export function get1LevelDict () {
  return request({
    url: '/manager/dicts/1level'
  })
}

export function getPipeLineMaterialOptions () {
  return request({
    url: '/pipe-network/pipes/pipe-line-material/option'
  })
}

export function getPipeDiameterSizeOptions () {
  return request({
    url: '/pipe-network/pipes/pipe-diameter-size/option'
  })
}

export function getPipeFindPoint () {
  return request({
    url: '/pipe-network/gis/pipe-networks/find/value'
  })
}

// 消防栓和排水阀

export function getXfsPsf (parameter) {
  return request({
    url: '/pipe-network/gis/pipe-networks/list-find-appendage',
    method: 'post',
    data: parameter
  })
}

// 互通阀门

export function getHutong (id) {
  return request({
    url: '/pipe-network/gis/pipe-networks/associated-valve/' + id,
    method: 'get'
  })
}
